import * as React from 'react';

export interface MonogramLogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /**
   * Optional title for accessibility
   */
  title?: string;
}

/**
 * Sree Silks Logo SVG Component
 * Usage: <MonogramLogo className="w-12 h-12" />
 */
export const MonogramLogo: React.FC<MonogramLogoProps> = ({ title = 'Sree Silks Logo', ...props }) => (
  <img src="/assets/optimized/icon-logo.webp" alt={title} width={160} height={160} loading="lazy" {...props} />
);
export default MonogramLogo;
